<template>
  <div class="page-header-index-wide">
    <a-button type="primary">
      <router-link to="/User/sort/addstory">
        <span>添加专栏</span>
      </router-link></a-button
    >
    <a-card :bordered="false">
      <a-tree
        show-line
        v-if="treeData.length > 0"
        :auto-expand-parent="autoExpandParent"
        :defaultExpandAll="true"
        :selected-keys="selectedKeys"
        :replace-fields="replaceFields"
        :tree-data="treeData"
        @select="onSelect"
        @check="onCheck"
        @expand="onExpand"
      >
        <template slot="sortName" slot-scope="item">
          <span>{{ item.sortName }}</span>
          <!-- <a-button
            type="primary"
            class="but_type"
            style="right: 200px"
            @click="() => append(item)"
            >新增</a-button
          > -->
          <a-button
            type="primary"
            class="but_type"
            style="right: 140px"
            icon="edit"
            @click="() => edit(item)"
            >编辑</a-button
          >

          <a-popconfirm
            placement="topRight"
            ok-text="是"
            cancel-text="否"
            @confirm="(e) => confirm(item)"
          >
            <template slot="title">
              <p>您确定删除{{ item.sortName }}这个分类？</p>
              <p>删除分类后,所属该分类的内容也将会删除</p>
              <p>建议隐藏分类，首页将不再会显示！</p>
            </template>
            <span class="but_type">
              <a-button
                type="danger"
                icon="delete"
                :disabled="!(item.children.length <= 0)"
                >删除</a-button
              >
            </span>
          </a-popconfirm>
        </template>
      </a-tree>
      <!-- </a-row> -->
      <div>
        <!-- <a-button type="primary" @click="showModal">
          Open Modal with customized footer
        </a-button> -->
        <a-modal
          v-model="visible"
          title="请输入操作密码"
          on-ok="handleOk"
          style="float: left"
        >
          <template slot="footer">
            <a-button key="back" style="float: left" @click="handleCancel">
              取消
            </a-button>
            <a-button
              key="submit"
              type="primary"
              :loading="loading"
              @click="handleOk"
            >
              提交
            </a-button>
          </template>
          <a-input-password
            v-model="captcha"
            placeholder="操作密码"
            autocomplete
          />
        </a-modal>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: "userstory",
  data() {
    return {
      autoExpandParent: true,
      replaceFields: {
        children: "children",
        title: "sortName",
        key: "id",
      },
      checkedKeys: [],
      selectedKeys: [],
      treeData: [],

      loading: false,
      visible: false,
      captcha: "",
      deleteDate: "",
    };
  },
    mounted() {
    this.init();
  },
   methods: {
   init() {
      this.$get("/vr/netuser/sort/select")
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.treeData = this.getAllTreeList(response.data);
          console.log(this.treeData)
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
          console.log(error);
        });
    },

    //整理数据
    getAllTreeList(list) {
      list.map((item) => {
        if (item.hasOwnProperty("children") && item.children.length > 0) {
          this.getAllTreeList(item.children);
        }
        item.scopedSlots = { title: "sortName" };
        item.disabled = !item.sortDisplay
        return item;
      });
      return list;
    },

    //删除
    confirm(data) {
      this.visible = true;
      this.deleteDate = data;
    },
    //密码框
    handleOk(e) {
      this.loading = true;
      this.$post("/vr/netuser/sort/delete/", {
        sortId: this.deleteDate.id,
        sortCode: this.deleteDate.sortCode,
        captcha: this.$Encrypt(this.captcha),
        token: this.$store.state.index.token,
      })
        .then((response) => {
          if (response.code != 1) {
            this.handleCancel();
            this.$message.error(response.msg, 5);
            return;
          }
          this.$message.success(
            "删除" + this.deleteDate.sortName + "分类成功",
            3
          );
          this.init();
          this.handleCancel();
        })
        .catch((error) => {
          console.log(error);
          this.handleCancel();
        });

      // setTimeout(() => {
      //   this.visible = false;
      //   this.loading = false;
      // }, 3000);
    },
    handleCancel() {
      (this.captcha = ""), (this.visible = false);
      this.loading = false;
    },

    edit(data) {
      //直接调用$router.push 实现携带参数的跳转
      // console.log(data);
      let updata = this.$qs.stringify(data);
      this.$router.push({
        path: `/User/sort/updatastory/${updata}`,
      });
    },

    onExpand(expandedKeys) {
      // console.log("onExpand", expandedKeys);
    },
    onCheck(checkedKeys) {
      // console.log("onCheck", checkedKeys);
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, info) {
      // console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
  },
  watch: {
    checkedKeys(val) {
      // console.log("onCheck", val);
    },
  },
};
</script>

<style lang="less" scoped>
.page-header-index-wide{
    padding: 10px;
    background-color:rgb(255, 255, 255);
}
.ant-tree-title {
  width: 100%;
}
.title {
  float: left;
}
.ant-card-body {
  :global {
    .ant-tree {
      line-height: 3;
      li {
        position: relative;
      }
    }
  }
}
.ant-card-body .but_type {
  float: right;
  position: absolute;
  right: 40px;
}
:global {
  .ant-modal-header .ant-modal-footer {
    border: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/sort/story.vue